document.addEventListener('DOMContentLoaded', function() {
  var loadSvgDetails = [
    {
      'selector': ['#shopify-section-template--24009034531143__173298802648394f84 #shopify-block-kehio_editor_app_block_faq_xiFMrp'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0863/7635/0023/files/F_Gradient_White.svg?v=1733046094',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '0',
        'width': '40%',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_3',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '40%'
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '40%'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '40%'
          },
          '(min-width: 1440px)': {
    		'width': '40%'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21471196152107__1686159157bc3d096d','#shopify-section-template--22578758320427__16900405694738ec8e','#shopify-section-template--22578784600363__16900357188b2b8cdb'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0741/2829/4187/files/K_Gradient_Orange.svg?v=1699536451',
      'css': {
        'position': 'absolute',
        'right': '0',
        'top': '0',
        'z-index': '0',
        'width': '100%',
        'opacity': '0.5',
        'class': 'svg_bg_4',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
  ];

  var resizeTimeout;//

  var resizeTimeout;

  for (var i = 0; i < loadSvgDetails.length; i++) {
    
    var selectors = loadSvgDetails[i].selector;
    var svgType = loadSvgDetails[i].svg;
    var cssProperties = loadSvgDetails[i].css;
    var mediaQueries = cssProperties.mediaQueries;
    var container = document.createElement('div');
    if(typeof loadSvgDetails[i].svg_url !== "undefined" && loadSvgDetails[i].svg_url != ''){
      var innerHtmlToAdd = '<img alt src="'+loadSvgDetails[i].svg_url+'" >';
    }else{
      var innerHtmlToAdd = svgData[svgType]
    }
    for (var s = 0; s < selectors.length; s++) {
      var selector = selectors[s];
      var element = document.querySelector(selector);
      if (element) {
        
        container.innerHTML = innerHtmlToAdd;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('dfredfd_container');
        container.classList.add(cssProperties.class);
        container.classList.add(cssProperties.class+'_'+s);
        container.classList.add('svg_bg_wrap');
        container.classList.add('fade_up_animate');
        //container.setAttribute('data-aos','fade-up');
        //container.setAttribute('data-aos-once','false');
       // if (window.scrollY === 0) {
         // container.setAttribute('data-aos-offset', '100');
       //   }
  
        applyCSSProperties(container, cssProperties);
  
        for (var mqQuery in mediaQueries) {
          var mqCSSProperties = mediaQueries[mqQuery];
  
          var mediaQueryList = window.matchMedia(mqQuery);
          mediaQueryList.addListener(createMediaQueryListener(container, mqCSSProperties));
  
          if (mediaQueryList.matches) {
            applyCSSProperties(container, mqCSSProperties);
          }
        }
        handleScroll();
        //Initialize AOS with desired options
        // AOS.init({
        //   duration: 1000,
        //   delay: 200,
        //   easing: 'ease-in-out',
        //  // data-aos-once
        //   // Add more options as needed
        // });
      } else {
        //console.log('Element with selector:', selector, ' not found.');
      }
    }
  }

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      for (var i = 0; i < loadSvgDetails.length; i++) {
        var selectors = loadSvgDetails[i].selector;
        
        var mediaQueries = loadSvgDetails[i].css.mediaQueries;
        for (var s = 0; s < selectors.length; s++) {
          var selector = selectors[s];
          
          var element = document.querySelector(selector);
  
          if (element) {
          //var container = element.querySelector('> .' + loadSvgDetails[i].css.class);
         // var childElements = Array.from(element.children);
          var container = document.querySelector(selector +' > .'+loadSvgDetails[i].css.class);

          for (var mqQuery in mediaQueries) {
            var mqCSSProperties = mediaQueries[mqQuery];
            var mediaQueryList = window.matchMedia(mqQuery);

            if (mediaQueryList.matches) {
              applyCSSProperties(container, mqCSSProperties);
            }
          }
        }
        }
      }
    }, 200); // Adjust the timeout duration as needed
  });
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        
        // Check if the top of the element has started entering the viewport from the bottom
        return rect.top >= 0 && rect.top < windowHeight;
    }
    
    function handleScroll() {
        const fadeUpElements = document.querySelectorAll('.fade_up_animate:not(.animated)');  // Select elements that are not yet visible
        //console.log(fadeUpElements.length)
        fadeUpElements.forEach(element => {
            if (isInViewport(element)) {
                element.classList.add('animated');
            }
        });
    }
    
    window.addEventListener('scroll', handleScroll);

  function createMediaQueryListener(element, properties) {
    return function(mql) {
      if (mql.matches) {
        applyCSSProperties(element, properties);
      }
    };
  }

  function applyCSSProperties(element, properties) {
    for (var property in properties) {
      if (property === 'class') {
        element.classList.add(properties[property]);
      } else {
        element.style[property] = properties[property];
      }
    }
  }
  var buttons = document.querySelectorAll('a[href="#discuteravecunexpert"]');

    // Iterate over the selected elements and bind the click event handler
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Code to execute when the button is clicked
        event.preventDefault();
        toggleDemoRequestForm();
        // Additional code...
      });
    });
    var imageSVG = '<?xml version="1.0" encoding="UTF-8"?><svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.59 93.94"><defs><style>.cls-1{fill:#772647;}</style></defs><g id="Calque_7"><path class="cls-1" d="M56.27,10.78c-.19,1.04-1.12,1.68-2.17,1.49s-1.68-1.12-1.49-2.17,1.12-1.68,2.17-1.49c1.05.19,1.68,1.12,1.49,2.17Z"/><path class="cls-1" d="M64.29,15.61l-.26-9.33-.03-.02-3.56,7.53-3.02-1.43L62.81.95l4.12,1.95.22,8.07.03.02,3.08-6.51,3.02,1.43-5.39,11.41-3.61-1.71Z"/><path class="cls-1" d="M79.6,14.74c-1.11,1.25-2.85,1.36-4.1.26-1.25-1.11-1.36-2.85-.26-4.1,1.11-1.25,2.85-1.36,4.1-.26,1.25,1.11,1.36,2.85.26,4.1ZM76.63,12.13c-.45.51-.44,1.13.03,1.55.48.43,1.11.37,1.57-.14s.43-1.14-.06-1.57c-.47-.42-1.09-.35-1.54.16Z"/><path class="cls-1" d="M76.96,27.24l7.43-4.99-3.78-1.85,2.78-1.86,4.36,2.13,1.49,2.22-10.48,7.03-1.8-2.68Z"/><path class="cls-1" d="M82.75,35.45c-1,.37-2.02-.1-2.39-1.1-.37-1,.1-2.02,1.1-2.39,1-.37,2.02.1,2.39,1.1.37,1-.1,2.02-1.1,2.39Z"/><path class="cls-1" d="M95.06,51.81c-.31,3.24-1.94,4.76-4.78,4.49-2.84-.27-4.16-2.08-3.85-5.31l.21-2.19-3.94-.38.33-3.44,12.56,1.2-.54,5.64ZM89.51,51.11c-.11,1.12.23,1.62,1.1,1.71.87.08,1.29-.35,1.4-1.47l.19-2.02-2.5-.24-.19,2.03Z"/><path class="cls-1" d="M81.63,56.24l11.61,4.93-1.35,3.18-8.78-3.73-2.29,5.38-2.83-1.2,3.64-8.57Z"/><path class="cls-1" d="M74.6,77.19c-2.84-2.47-3.02-5.07-.57-7.89,2.43-2.8,5.01-2.95,7.85-.48l5.44,4.72-2.27,2.61-5.25-4.56c-1.41-1.22-2.56-1.29-3.5-.2-.95,1.09-.72,2.22.69,3.44l5.25,4.56-2.19,2.52-5.44-4.72Z"/><path class="cls-1" d="M58.91,79.97l3.71,7.73.03-.02-1.02-9.02,2.64-1.27,6.16,6.2.03-.02-3.57-7.44,3.02-1.45,5.46,11.38-4.64,2.23-5.66-5.78-.03.02.97,8.03-4.75,2.28-5.46-11.38,3.12-1.5Z"/><path class="cls-1" d="M55.67,93.49l-3.43.45-1.64-12.51,3.43-.45,1.64,12.51Z"/><path class="cls-1" d="M35.78,86.21c-1.01-.83-1.4-1.92-1.13-3.19.5-2.26,2.65-3.17,5.78-2.48,1.73.38,3.21,1.14,3.92,1.99l-.73,3.32-.15-.03c-.6-1.14-2.05-2.11-3.6-2.45-1.17-.26-1.92.04-2.1.9-.15.69.31,1.04,1.82,1.37l1.56.34-.57,2.6-1.37-.3c-1.5-.33-2.08-.2-2.23.48-.19.85.33,1.43,1.44,1.68,1.34.29,2.87.03,3.91-.7l.15.03-.73,3.32c-1.1.42-2.7.44-4.28.09-2.89-.64-4.33-2.33-3.83-4.6.26-1.19,1.02-1.99,2.15-2.35v-.04Z"/><path class="cls-1" d="M22.82,87.09c-3.67-2.3-4.5-5.49-2.35-8.92,2.15-3.43,5.38-4.07,9.05-1.77l4.39,2.75-6.7,10.69-4.39-2.75ZM28.06,79.12c-1.96-1.23-3.48-.92-4.63.91s-.76,3.33,1.2,4.56l1.29.81,3.43-5.47-1.29-.81Z"/><path class="cls-1" d="M20.75,69.21l-10.56,6.9-1.89-2.89,7.98-5.22-3.2-4.9,2.58-1.68,5.09,7.79Z"/><path class="cls-1" d="M5.69,54.85l2.7-.78,1.31,4.57,1.73-.5-1.69-5.88,2.96-.85,2.65,9.21-12.13,3.49-2.65-9.21,2.96-.85,1.69,5.88,1.77-.51-1.31-4.57Z"/><path class="cls-1" d="M6.34,47.25c2.11.09,3.48-1.31,3.58-3.63.01-.3,0-.61-.02-.91l-1.61-.07-.1,2.22-2.81-.12.25-5.54,6.72.3c.54,1.2.72,2.58.64,4.42-.19,4.37-2.82,7.01-6.81,6.83-3.99-.18-6.37-3.04-6.18-7.41.08-1.84.39-3.2,1.03-4.35l3.74.17v.15c-1.06,1.02-1.62,2.4-1.69,4.02-.1,2.32,1.14,3.83,3.25,3.93Z"/><path class="cls-1" d="M8.55,33.11c1.95.81,3.72-.04,4.61-2.19.12-.28.21-.57.3-.86l-1.49-.62-.85,2.06-2.6-1.08,2.12-5.13,6.22,2.57c.09,1.31-.2,2.67-.91,4.38-1.67,4.04-5.04,5.63-8.73,4.1-3.69-1.53-4.95-5.03-3.28-9.07.7-1.7,1.46-2.87,2.45-3.74l3.46,1.43-.06.14c-1.34.6-2.33,1.71-2.95,3.2-.89,2.14-.23,4,1.72,4.8Z"/><path class="cls-1" d="M8.62,19.27l2.08-2.76,10.08,7.59-2.08,2.76-10.08-7.59Z"/><path class="cls-1" d="M27.58,17.82l-8.45-3.95-.03.02,5.13,6.55-2.63,2.06-7.78-9.93,3.59-2.81,7.31,3.42.03-.02-4.44-5.67,2.63-2.06,7.78,9.93-3.14,2.46Z"/><path class="cls-1" d="M32.78,7.9c.64,2.01,2.42,2.82,4.63,2.12.29-.09.57-.2.85-.33l-.49-1.54-2.12.67-.85-2.68,5.29-1.67,2.03,6.41c-.95.92-2.18,1.56-3.93,2.12-4.17,1.32-7.55-.25-8.75-4.05-1.2-3.8.67-7.02,4.83-8.34,1.76-.55,3.14-.73,4.44-.53l1.13,3.57-.15.05c-1.32-.64-2.81-.69-4.35-.2-2.21.7-3.21,2.39-2.57,4.4Z"/></g></svg>';
    var imageSelector = [
      {'selector':'#shopify-section-template--25121721254231__174026178832ed8fae #faq_body_7708_info_7_1_1 > div','type':'left_svg'},
      {'selector':'#shopify-section-template--25121721254231__1740261838c2b7d838 #faq_body_7711_info_10_1_1 > div','type':'right_svg'}
    ];
    
    for (var s = 0; s < imageSelector.length; s++) {
      var selectorImg = imageSelector[s];
     // console.log('selector',selectorImg);
      var element = document.querySelector(selectorImg.selector);
      if (element) {
        var container = document.createElement('div');
        container.innerHTML = imageSVG;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('image_svg_contain');
        container.classList.add('image_svg_wrap');
        container.classList.add(imageSelector[s].type);
      }
    }

    

});
